import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { Mutations } from './mutations';
import { RenderingMutationTypes as MutationTypes } from './mutation-types';
import { RenderingActionTypes as ActionTypes } from './action-types';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [ActionTypes.SET_CAMERA_POS]({ commit }: AugmentedActionContext, payload: number): void;
}

export const actions: ActionTree<State, RootState> & Actions = {
  [ActionTypes.SET_CAMERA_POS]({ commit }, payload: number) {
    commit(MutationTypes.SET_CAMERA_POS, payload);
  },
};
